import { takeEvery, takeLatest, call, put } from 'redux-saga/effects';
import * as gnbMenuActions from 'redux/ducks/GnbMenu/GnbMenuDucks';
import * as popupActions from 'redux/ducks/common/popupDucks';
import portalApi from 'api/portal/portalApi';

export function* createGnbMenu({ payload }) {
  try {
    const response = yield call(portalApi.createMenu, payload);
    yield put(gnbMenuActions.createGnbMenuSuccess(response.result));
    yield put(gnbMenuActions.updateGnbMenu(response.menu));
  } catch (error) {
    // temp
    yield put(popupActions.closeProgressPopup());
    yield put(gnbMenuActions.createGnbMenuFail(error));
  }
}

export function* deleteGnbMenu({ payload }) {
  try {
    const response = yield call(portalApi.deleteMenu, payload);
    if (response.result === 'success') yield put(gnbMenuActions.deleteGnbMenuSuccess(payload));
  } catch (error) {
    yield put(gnbMenuActions.deleteGnbMenuFail(error));
  }
}

export default function* GnbMenuSaga() {
  yield takeEvery(gnbMenuActions.createGnbMenu, createGnbMenu);
  yield takeLatest(gnbMenuActions.deleteGnbMenu, deleteGnbMenu);
}
